// extracted by mini-css-extract-plugin
module.exports = {"deliveryDateGroupHeader":"placedOrders_deliveryDateGroupHeader__1TgLd","deliveryDateCell":"placedOrders_deliveryDateCell__SVWMg"};